import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Get } from "../../../Services/Server";
import Url from "../../../Services/Url";
import DataTable from "../../../Components/DataTable/DataTable";
import PageHead from "../../../Components/PageHead/PageHead";
import css from "./PaymentTerms.module.css";
import Utils from "../../../Services/Utills";
import Time from "../../../Services/Time";

const PaymentTermsList = ({ navoption }) => {
	const navigate = useNavigate();
	const [initial, setContracts] = useState({
		heading: ["Company", "Job", "Submitted By", "Submitted On"],
		data: [],
	});
	const [view, setView] = useState("pending");
	const [loading, setLoading] = useState(true);
	const flex = [25, 20, 25, 30];

	const fetchContracts = (status) => {
		setLoading(true);
		Get(Url.sales.getContractsByStatus(status))
			.then((response) => {
				setContracts({
					heading: ["Company", "Job", "Submitted By", "Submitted On"],
					data: response,
				});
				console.log(response);
			})
			.catch((error) => {
				console.error("Error fetching contracts:", error);
			})
			.finally(() => setLoading(false));
	};

	useEffect(() => {
		fetchContracts(view);
	}, [view]);

	const contractReader = (initial) => {
		return [
			initial?.company?.name || "-",
			`${initial?.equipment[0]?.service?.name} of ${initial?.equipment[0]?.equipment}`,
			initial?.contract?.contractReview?.reviewedBy?.fullName || "N/A",
			Time.getDate(initial?.contract?.contractReview?.createdAt) || "N/A",
		];
	};

	const dropOptions = {
		onClick: (e) => {
			const op = e.find((o) => o.selected);
			const selected = op
				? op.text.toLowerCase().replace(" terms", "")
				: "pending";
			setView(selected);
		},
		list: ["Pending Terms", "Approved Terms", "Disapproved Terms"],
	};

	return (
		<div className={css.Page}>
			<PageHead
				navoption={navoption}
				dropOptions={dropOptions}
				filter={Utils.toPascalCase(view) + " Terms"}
				title="Terms"
			/>
			<div>
				{loading ? (
					<div>Loading...</div>
				) : (
					<DataTable
						children={initial}
						reader={contractReader}
						onClick={(e) => navigate(`${e.id}`)}
						flex={flex}
					/>
				)}
			</div>
		</div>
	);
};

export default PaymentTermsList;
